import { GUIDE } from './page-guide.model';

/** Map steps the tour may open itself, so they are not dropped while the card is closed. */
export type GuideRevealKind = 'map-point' | 'map-line' | 'map-route';

const POINT = new Set<string>([
  GUIDE.mapPopupHeader,
  GUIDE.mapPointType,
  GUIDE.mapPointMilestones,
  GUIDE.mapPointSpec,
  GUIDE.mapRozvadecMilestones,
  GUIDE.mapRozvadecSpec,
  GUIDE.mapBtnDelete,
  GUIDE.mapBtnMove,
  GUIDE.mapBtnRename,
  GUIDE.mapBtnInfo,
  GUIDE.mapBtnClose,
  GUIDE.mapBtnPhotos,
  GUIDE.mapBtnMaterial,
  GUIDE.mapBtnNote,
  GUIDE.mapBtnShare,
  GUIDE.mapBtnSurfaces,
  GUIDE.mapBtnWelds,
  GUIDE.mapBtnSpec,
  GUIDE.mapPopupActions,
  GUIDE.mapPopupPhases,
  GUIDE.mapPopupAcq,
]);

const LINE = new Set<string>([
  GUIDE.mapLineRoute,
  GUIDE.mapLinePhase,
  GUIDE.mapRouteChoose,
  GUIDE.mapRouteNew,
]);

const ROUTE = new Set<string>([
  GUIDE.mapVykopConfirm,
  GUIDE.mapRouteConfirm,
  GUIDE.mapRouteCancel,
]);

export function revealKindForGuideTarget(target: string): GuideRevealKind | null {
  if (POINT.has(target)) return 'map-point';
  if (LINE.has(target)) return 'map-line';
  if (ROUTE.has(target)) return 'map-route';
  return null;
}
